// Open level 02
document.querySelectorAll('.btn.header_navigation_layer_navigation_link').forEach((element) => {
  element.addEventListener('click', (e) => {
    const navigationLinkButton = e.target;

    for (const sibling of navigationLinkButton.parentNode.children) {
      if (sibling !== navigationLinkButton) sibling.classList.add('is-active');
    }
  });
});

// Back link
let headerNavigationLayerLvl02 = document.getElementsByClassName('header_navigation_layer_lvl_02');
document.querySelectorAll('.btn.header_navigation_layer_back-link').forEach((element) => {
  element.addEventListener('click', () => {
    for (let i =0; i < headerNavigationLayerLvl02.length; i++) {
      headerNavigationLayerLvl02[i].classList.remove('is-active');
    }
  });
});
